import { ErrorVariant } from './error/constants'
import { ErrorPage } from './error/Errors'

export function NotFoundErrorPage() {
  return (
    <main>
      <ErrorPage variant={ErrorVariant.NotFound} />
    </main>
  )
}
